export default __webpack_public_path__ + "static/media/martin_anz.b8a65f5f.png";